'use client'

import styles from './styles.module.css'
import { Breadcrumbs } from '../_components/Breadcrumps'

export default function BlogsLayout({ children }: { children: React.ReactNode }) {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumps} />
			<main className={styles.main}>{children}</main>
		</>
	)
}
